import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import LandingHeader from '../components/LandingHeader';
import { blogPosts } from '../content/blogPosts';
import { isIOSDevice } from '../utils/deviceDetection';

const BlogIndexPage: React.FC = () => {
  const isIOS = isIOSDevice();

  return (
    <div className="public-scroll-page bg-white">
      <Helmet>
        <title>DinnerBrain Blog | Meal Planning Without the Mental Load</title>
        <meta
          name="description"
          content="Practical meal planning ideas for reducing dinner decision fatigue, organizing favorite recipes, and making weeknights calmer."
        />
      </Helmet>
      <LandingHeader />
      <main style={{ paddingTop: isIOS ? 'calc(5rem + env(safe-area-inset-top, 0px))' : '5rem' }}>
        <section className="bg-[#E6EFEA] px-4 py-16 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-4xl text-center">
            <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#4A6651]">
              DinnerBrain Blog
            </p>
            <h1 className="mb-6 text-4xl font-bold text-slate-900 sm:text-5xl" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Meal planning without the mental load.
            </h1>
            <p className="mx-auto max-w-2xl text-lg text-slate-600">
              Practical notes for organizing the meals you already trust, making grocery lists less chaotic, and getting dinner decided with less drama.
            </p>
          </div>
        </section>

        <section className="px-4 py-14 sm:px-6 lg:px-8">
          <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-3">
            {blogPosts.map((post) => (
              <article key={post.slug} className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-md">
                <div className="mb-4 text-sm text-slate-500">
                  {post.readTime} · {new Date(post.date).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
                </div>
                <h2 className="mb-3 text-xl font-semibold text-slate-900">
                  <Link to={`/blog/${post.slug}`} className="hover:text-[#4A6651]">
                    {post.title}
                  </Link>
                </h2>
                <p className="mb-5 flex-1 text-slate-600">{post.description}</p>
                <p className="mb-5 rounded-full bg-[#E6EFEA] px-4 py-2 text-sm text-[#4A6651]">
                  For: {post.audience}
                </p>
                <Link
                  to={`/blog/${post.slug}`}
                  className="inline-flex min-h-[44px] items-center justify-center rounded-full bg-[#4A6651] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#3d5444]"
                >
                  Read article
                </Link>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogIndexPage;
